export const user = (state) => state.user;
export const isAuthenticating = (state) => state.isAuthenticating;

export const displayName = (state) => (state.user
  ? `${state.user.first_name} ${state.user.last_name}`
  : state.user.email);
